import React from 'react';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';
import IconBack from '../../components/UISystem/Icons/IconBack';
import { TypographyExample, TEXT_STYLES } from '../../components/UISystem/Typography';

/**
 * Typography Screen - UI System subpage
 *
 * Displays the typography system documentation using reusable typography components
 */
const TypographyScreen = ({ onBack }) => {
  return (
    <div style={UI_SCREEN_STYLES.container}>
      {/* Header with back button and title */}
      <div style={UI_SCREEN_STYLES.header}>
        {/* Back button */}
        <IconBack onClick={onBack} />

        {/* Title */}
        <h1 style={UI_SCREEN_STYLES.title}>Typography</h1>
      </div>

      {/* Horizontal line */}
      <div style={UI_SCREEN_STYLES.divider} />

      {/* Content */}
      <div style={UI_SCREEN_STYLES.content}>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#6D7074', marginTop: 0 }}>
          Typography Tokens
        </h2>

        {/* Typography examples */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <div>
            {TEXT_STYLES.map((style, index) => (
              <TypographyExample
                key={index}
                name={style.name}
                style={style.style}
                description={style.description}
                usage={style.usage}
              />
            ))}
          </div>

          <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#6D7074', marginTop: '32px' }}>
            Font Family
          </h2>
          <div style={{ fontSize: '16px', color: '#6D7074', lineHeight: '1.5' }}>
            System fonts: &lsquo;-apple-system&rsquo;, &lsquo;BlinkMacSystemFont&rsquo;,
            &lsquo;Segoe UI&rsquo;, &lsquo;Roboto&rsquo;, &lsquo;Oxygen&rsquo;
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypographyScreen;
